import { useEffect, useContext } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { work_spaceActions, alertActions, content_groupActions } from "../../../../actions";
import { buildFormDataFromObject, adminBaseURL } from '../../../../utils/commonUtils';
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Button } from "react-bootstrap";
import CardGroup from "./card_group";
import EmptyStage from '../../../../images/empty-stage.png';
import { WorkspaceShowContext } from "../../../../contexts/WorkspaceShowContext";
import { CircleAddIcon } from '../../../../components';
import handleDragEndCard from '../../../../handlers/handleDragEndCard';
import { NEW_STAGE_MODAL_ACTIONS } from '../../../../constants/stage.constants';

function Board(props) {
  const {
    stages,
    content_groups,
    workspace_id,
    organization_id,
    can_crud_content_group,
    can_access_move_content_board,
    can_access_move_stage_board,
    can_access_edit_title,
    can_access_show_content_details,
    can_access_approval_dots,
    can_access_edit_label
  } = props;
  const dispatch = useDispatch();
  const workspaceBaseUrl = adminBaseURL("workspaces");
  const rows = useSelector(state => state.stage.stages);

  const {
    can_access_stage,
    getStages,
    updateRecords
  } = useContext(WorkspaceShowContext);

  useEffect(() => {
    updateRecords(props);
  }, []);

  useEffect(() => {
    //updateRecords(props);
  }, [props.stages]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const visibleDivObserver = new IntersectionObserver((entries, imgObserver) => {
        var collect_id = []
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const find_value = entry.target
            if (find_value.getAttribute('data-image-pending') == 'true') {
              collect_id.push(find_value.getAttribute('data-id'));
              find_value.setAttribute('data-image-pending', 'false');
            }
          }
        })
        if(collect_id.length > 0) {
          var content_groups_id = collect_id
          dispatch(content_groupActions.replaceContentImageLazeLoading(workspace_id, content_groups_id ));
        }
      });
      var visible_div = document.querySelectorAll("#parent_div_board > div > div > div > div .visible_board_div");
      visible_div.forEach((v) => {
        visibleDivObserver.observe(v);
      })
    }, 300);
    return () => clearTimeout(timer);
  }, [rows]);

  const setNewStageFormPopup = (e) => {
    e.preventDefault();
    
    const boundary = e.target.getBoundingClientRect();

    dispatch({ type: NEW_STAGE_MODAL_ACTIONS.OPEN_NEW_STAGE_MODAL, payload: boundary });
  }


  /*
    Update BackEnd
  */

  const onDragEnd = (result) => {
    if(can_access_move_content_board) {
      handleDragEndCard({
        result,
        stages: rows,
        dispatch,
        workspace_id
      })
    }else {
      dispatch(alertActions.error("You are not authorized to access this page"));
    }
  }

  let column_length = rows.length;
 
  return (
    <>
      {
        column_length == 0  ?
          <div className="container layout__container-wrapper container--workspace-list">
            <div style={{ textAlign: 'center', marginTop: '2rem', marginBottom: '2rem' }}>
              <img src={ EmptyStage } style={{ width: "500px", maxWidth: '100%', textAlign: 'center' }} />
              <p className="mt-3" style={{ fontWeight: '600', fontSize: '1.4rem' }}>This workspace has no stage yet.</p>

              { can_access_stage &&
              <div className='d-grid'>
                <Button variant="dashed" onClick={setNewStageFormPopup} className="mt-3 d-inline-block h-36px" size={'sm'}>
                  Add stage
                </Button>
              </div>
                
              }
            </div>
          </div>
        :
        <DragDropContext
          onDragEnd={onDragEnd}
          style={{ maxHeight: "100%" }}
        >
          <Droppable
            droppableId="Board"
            type="COLUMN"
            direction="horizontal"
          >
            {(provided, snapshot) => {
              return (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="kanban-board-stages"
                  id="parent_div_board"
                >
                  {rows.map((column, index) => {
                    return (
                      <CardGroup
                        key={column.id}
                        index={index}
                        column={column}
                        content_groups={content_groups}
                        can_crud_content_group={can_crud_content_group}
                        workspace_id={workspace_id}
                        organization_id={organization_id}
                        can_access_move_content_board={can_access_move_content_board}
                        can_access_edit_title={can_access_edit_title}
                        can_access_move_stage_board={can_access_move_stage_board}
                        can_access_show_content_details={can_access_show_content_details}
                        can_access_approval_dots={can_access_approval_dots}
                        can_access_edit_label={can_access_edit_label}
                      />
                    );
                  })}

                  {provided.placeholder}

                  <Draggable
                    draggableId={column_length.toString()}
                    index={column_length}
                    isDragDisabled={true}
                  >
                    {(provided, snapshot) => {
                      return (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="kanban-card-group add-button d-flex empty_card_group"
                          style={{
                            userSelect: "none",
                            ...provided.draggableProps.style,
                          }}
                        >
                          {can_access_stage &&
                            <div className='add-stage-container pe-5'>
                              <Button
                                onClick={setNewStageFormPopup}
                                className="h-36px" 
                                title="Add Stage"
                                variant={'dashed'}
                              >
                                Add Stage
                              </Button>

                              {
                                rows.length == 0 &&
                                <p className="mt-3">No available stage.</p>
                              }
                            </div>
                          }
                        </div>
                      );
                    }}
                  </Draggable>

                </div>
              );
            }}
          </Droppable>
        </DragDropContext>
      }
    </>
  );
}

export default Board
